import { BaseURLs } from '@/types/Enums/BaseURLs'

const isLocal = window.location.hostname === 'localhost'

const port = {
  apiUser: BaseURLs.API_USER,
  apiPost: BaseURLs.API_POST,
  apiCompany: BaseURLs.API_COMPANY,
  apiMessage: BaseURLs.API_MESSAGE,
  apiPoint: BaseURLs.API_POINT,
  apiCommon: BaseURLs.API_COMMON,
  apiHub: BaseURLs.API_HUB,
  apiReport: BaseURLs.API_REPORT,
  apiWebhook: BaseURLs.API_WEBHOOK,
}

/*
Localde dev sunucusunu kullanmak için true yapın, false olarak bırakın
*/
const useLocalDev: boolean = false

const apiMaker = (service: string) => {
  if (isLocal) {
    if (useLocalDev) {
      return 'https://admin.dev.empactivo.com/' + service + '/'
    } else {
      return port[service as keyof typeof port]
    }
  } else {
    return `${window.location.origin}/${service}/`
  }
}

export { apiMaker, isLocal, useLocalDev }
